import { OrderService } from '../services';

const namespace = 'orders';

export const GET_ORDERS = `${namespace}/GET_ORDERS`;
export const ORDERS_RECEIVED = `${namespace}/ORDERS_RECEIVED`;
export const ORDERS_AT_FACILITY_RECEIVED = `${namespace}/ORDERS_AT_FACILITY_RECEIVED`;
export const ORDERS_ON_DOC_RECEIVED = `${namespace}/ORDERS_AT_FACILITY_DOC`;

export const ORDER_SAVED = `${namespace}/ORDER_SAVED`;
export const SAVE_ORDER_DETAILS = `${namespace}/SAVE_ORDER_DETAILS`;
export const VOID_ORDER = `${namespace}/VOID_ORDER`;
export const ORDER_VOIDED = `${namespace}/ORDER_VOIDED`;

export const GET_DELIVERED = `${namespace}/GET_DELIVERED`;
export const DELIVERED_RECEIVED = `${namespace}/DELIVERED_RECEIVED`;

export const GET_ORDER = `${namespace}/GET_ORDER`;
export const ORDER_RECEIVED = `${namespace}/ORDER_RECEIVED`;

export function getAllOrders() {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.auth) {
      
    }
    dispatch(getAll());
    return OrderService.getAll(state.auth.auth)
      .then(json => { return dispatch(ordersReceived(json))});
  }
}

function getAll() {
  return {
    type: GET_ORDERS
  }
}

function ordersReceived(orders) {
  return {
    type: ORDERS_RECEIVED,
    orders
  }
}

function ordersAtFacilityReceived(orders) {
  return {
    type: ORDERS_AT_FACILITY_RECEIVED,
    orders
  }
}

function ordersOnDockReceived(orders) {
  return {
    type: ORDERS_ON_DOC_RECEIVED,
    orders
  }
}

export function getDelivered() {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.auth) {

    }
    dispatch(getDeliveredOrders());
    return OrderService.getAll(state.auth.auth, 'status=delivered')
      .then(json => { return dispatch(deliveredReceived(json))});
  }
}

function getDeliveredOrders() {
  return {
    type: GET_DELIVERED
  }
}

function deliveredReceived(orders) {
  return {
    type: DELIVERED_RECEIVED,
    orders,
  }
}

export function saveOrder(order) {
  return (dispatch, getState) => {
    const state = getState();
    return OrderService.saveOrder(state.auth.auth, order)
      .then(json => {
        return dispatch(orderSaved(json));
      });
  }
}

function orderSaved(order) {
  return {
    type: ORDER_SAVED,
    order
  }
}

/*
function saveOrderDetails(from, to) {
  return {
    type: SAVE_ORDER_DETAILS,
    from,
    to
  }
}
*/

export function updateOrder(order) {
  return (dispatch, getState) => {
    const state = getState();
    return OrderService.updateOrder(state.auth.auth, order)
      .then(json => dispatch(orderSaved(json)));
  }
}


function voidingOrder() {
  return {
    type: VOID_ORDER
  }
}
function orderVoided() {
  return {
    type: ORDER_VOIDED
  }
}


export function voidOrder(trackingNumber) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(voidingOrder());
    return OrderService.voidOrder(state.auth.auth, trackingNumber)
    .then(() => {
      dispatch(getAllOrders())
      dispatch(orderVoided());
    });
  }
}

export function updateOrders(orders) {
  return (dispatch, getState) => {
    const state = getState();
    return OrderService.updateOrders(state.auth.auth, orders);
  }
}

export function getOrderByTrackingNumber(tracking) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(getOrder());
    return OrderService.getOrderByTrackingNumber(state.auth.auth, tracking)
    .then((json) => {
      dispatch(orderReceived(json));
      return json;
    });
  }
}

function getOrder() {
  return {
    type: GET_ORDER
  }
}

function orderReceived(order) {
  return {
    type: ORDER_RECEIVED,
    order
  }
}

export function scanIn(trackingNumber) {
  return (dispatch, getState) => {
    const state = getState();
    return OrderService.scanInByTrackingNumber(state.auth.auth, trackingNumber)
    .then(json => dispatch(orderReceived(json)));
  }
}

export function getAtFacility() {
  return (dispatch, getState) => {
    const state = getState();
    return OrderService.getAll(state.auth.auth, 'status=here')
    .then(json => dispatch(ordersAtFacilityReceived(json)));
  }
}

export function getOnDoc() {
  return (dispatch, getState) => {
    const state = getState();
    return OrderService.getAll(state.auth.auth, 'status=pending')
    .then(json => dispatch(ordersOnDockReceived(json)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/OrderActions.js